// extracted by mini-css-extract-plugin
export default {"primaryColor":"#642472","mainTextColorOnPrimary":"#fff","setting":"Setting_setting__bwdA2","settingContent":"Setting_settingContent__Lyx66"};